import ListingTileSkeleton from './ListingTileSkeleton';

/**
 * Placeholder tiles for the browse GRID while its first page is in flight.
 *
 * The grid — not the showcase strip — is what home and the category pages
 * actually render by default: `searchViewMode` starts at `'grid'`
 * (contexts/UIProvider.tsx) and only becomes `'showcase'` if the reader has
 * chosen it and localStorage says so. So the showcase skeleton, which was the
 * only one, covered the view most readers never see, while the common path
 * showed an empty `.listing-cont` and popped the tiles in when they landed.
 *
 * It renders the real `.listing-cont` (styles/components/listing.scss), whose
 * `auto-fill` template decides the column count per breakpoint — five columns
 * above 1640px, four below it, two under 800px. That means the placeholder
 * reflows exactly as the loaded grid does, at every width, without this file
 * knowing any of those numbers.
 */

interface ListingGridSkeletonProps {
  /**
   * How many tiles. Twelve fills the first screen at every column count
   * (three rows of four, two and a bit rows of five) without paying for tiles
   * below the fold that the real page will replace before they are scrolled to.
   */
  tiles?: number;
}

export function ListingGridSkeleton({ tiles = 12 }: ListingGridSkeletonProps) {
  return (
    <div
      className="listing-cont"
      data-testid="listing-grid-skeleton"
      aria-hidden="true"
    >
      {Array.from({ length: tiles }, (_, i) => (
        <ListingTileSkeleton key={`listing-skeleton-${i}`} />
      ))}
    </div>
  );
}

export default ListingGridSkeleton;
